export default class TrailerModel {
    constructor() {
        this.sapId = undefined;
        this.number = '';
        this.registrationNumber = '';
        this.oldRegistrationNumber = '';
        this.name = '';
        this.type = '';
        this.own = true;
    }

    static assign(from, to) {
        if (from) {
            to.sapId = from.sapId ? from.sapId : undefined;
            to.number = from.number ? from.number : '';
            to.registrationNumber = from.registrationNumber ? from.registrationNumber : '';
            to.oldRegistrationNumber = from.oldRegistrationNumber ? from.oldRegistrationNumber : '';
            to.name = from.name ? from.name : '';
            to.type = from.type ? from.type : '';
            to.own = from.own;
        } else {
            to = new TrailerModel();
        }
    }

    static copy(from) {
        const to = new TrailerModel();
        TrailerModel.assign(from, to);
        return to;
    }
}